import { CloseCircleFilled } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import { useMetaSignup } from 'components/Meta/useMetaSignup';
import React, { useLayoutEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

const STEPS = [
	{ id: 'meta_connect_step_1' },
	{
		id: 'meta_connect_step_2',
		href: 'https://business.facebook.com/latest/settings/business_info?business_id=1735950417339899',
	},
	{
		id: 'meta_connect_step_3',
		href: 'https://business.facebook.com/billing_hub/accounts?business_id=1735950417339899&placement=standalone&account_type=whatsapp-business-account',
	},
	{
		id: 'meta_connect_step_4',
		href: 'https://business.facebook.com/latest/whatsapp_manager/message_templates?business_id=1735950417339899&tab=message-templates&nav_ref=whatsapp_manager&asset_id=2030816010774954',
	},
];

const FAILURE_MESSAGE = {
	interrupted: 'meta_connect_error_interrupted',
	account: 'meta_connect_error_description',
};

export default function MetaConnectScreen({ formNumber, onFinish }) {
	const { sdkReady, loading, failure, launch } = useMetaSignup(formNumber, onFinish);
	const launched = useRef(false);

	// Abre o popup da Meta sem clique extra. A tela monta no mesmo clique de "Continuar
	// configuração" (commit síncrono do React 18), então com o SDK já carregado - a tela de
	// escolha pré-carrega - o FB.login ainda roda dentro do gesto e o navegador não bloqueia.
	useLayoutEffect(() => {
		if (sdkReady && !launched.current) {
			launched.current = true;
			launch();
		}
	}, [sdkReady]);

	return (
		<div className="qr-screen meta-connect-screen">
			<div className="qr-screen-instructions">
				<h1 className="qr-screen-title">
					<FormattedMessage id="qr_title" />
				</h1>
				<p className="qr-screen-subtitle">
					<FormattedMessage id="meta_connect_subtitle" />
				</p>
				<p className="qr-screen-before">
					<FormattedMessage id="meta_connect_intro" />
				</p>
				<ol className="meta-connect-steps">
					{STEPS.map(({ id, href }) => (
						<li key={id}>
							<FormattedMessage
								id={id}
								values={{
									link: (chunks) => (
										<a href={href} target="_blank" rel="noopener noreferrer">
											{chunks}
										</a>
									),
								}}
							/>
						</li>
					))}
				</ol>
				{loading && (
					<div className="meta-connect-status" role="status">
						<Spin size="small" />
						<FormattedMessage id="meta_connecting" />
					</div>
				)}
			</div>
			{failure && (
				<div className="meta-connect-error" role="alert">
					<CloseCircleFilled className="meta-connect-error-icon" />
					<div>
						<div className="meta-connect-error-title">
							<FormattedMessage id="meta_connect_error_title" />
						</div>
						<div className="meta-connect-error-description">
							<FormattedMessage id={FAILURE_MESSAGE[failure]} />
						</div>
						<Button type="link" className="meta-connect-error-retry" onClick={launch}>
							<FormattedMessage id="meta_connect_retry" />
						</Button>
					</div>
				</div>
			)}
		</div>
	);
}
